import React from 'react';
import FoodCard from '../components/FoodCard';

export interface IFoodMenuDay {
    index: number;
    title: string;
    longTitle: string;
    content: React.ReactNode;
}

export const foodDays: { [key: number]: IFoodMenuDay } = {
    0: {
        index: 0,
        title: "Fri",
        longTitle: "Friday 🎉",
        content: (
            <FoodCard
                mealType="dinner"
                restaurant="Shawarma Palace 🌯"
                time="18:00"
                items={[
                    ['Wraps', 'Falafel, chicken or beef with a soft pita bread, topped with hummus, garlic sauce and assortment of fresh pickles, lettuce, turnip, onion and tomatoes'],
                    ['Falafel', 'Chickpeas, parsley, garlic, cumin, smoked paprika, wheat'],
                    ['Garlic Sauce', 'Garlic, oil, lemon, egg'],
                ]}
                imageSrc={require('../assets/shawarmapalace.webp')}
            />
        ),
    },
    1: {
        index: 1,
        title: "Sat",
        longTitle: "Saturday 🕺",
        content: (
            <>
                <FoodCard
                    mealType="breakfast"
                    restaurant="Breakfast 🥐"
                    time="8:00"
                    items={[
                        ['Baked Goods', 'Muffins (banana chocolate chip/chocolate chip/double chocolate), croissants'],
                        ['Fruits', 'Apples, clementines, bananas'],
                        ['Beverages', 'Coffee, tea, water']
                    ]}
                    imageSrc={require('../assets/images/muffins.png')}
                />

                <FoodCard
                    mealType="lunch"
                    restaurant="BanhMiYes 🥖"
                    time="12:00"
                    items={[
                        ['Grilled Beef (Halal)', 'Halal ground beef with homemade sauce, Vietnamese kimchi, coriander, and hot sauce.'],
                        ['Pulled Chicken', 'Tender chicken with mayo, pickled carrot, cucumber, and coriander.'],
                        ['Tofu & Veggie Pork', 'Crispy tofu with veggie pork, pickles, cucumber, and green onion.']
                    ]}
                    imageSrc={require('../assets/banhmiyes.webp')}
                />

                <FoodCard
                    mealType="dinner"
                    restaurant="Kara Mia 🍝"
                    time="18:00"
                    items={[
                        ['Chiken Pasta', ' Diced chicken breast, onions, bell peppers and penne pasta in a spicy rosé sauce.'],
                        ['Sausage Pasta', 'Spicy Italian sausage sautéed with bell peppers, onions, cayenne peppers, finished in a spicy rosé sauce. '], 
                        ['Veggie Pasta', 'Pasta sauteed with bell peppers, mushrooms, onions and penne pasta in a saffron cream sauce.'],
                    ]}
                    imageSrc={require('../assets/karamia.jpg')}
                />
            </>
        ),
    },
    2: {
        index: 2,
        title: "Sun",
        longTitle: "Sunday 🌅",
        content: (
            <>
                <FoodCard
                    mealType="breakfast"
                    restaurant="Breakfast 🥐"
                    time="8:00"
                    items={[
                        ['Baked Goods', 'muffins (banana chocolate chip/chocolate chip/double chocolate), croissants'],
                        ['Fruits', 'Apples, clementines, bananas'],
                        ['Beverages', 'Coffee, tea, water, redbull']
                    ]}
                    imageSrc={require('../assets/images/muffins.png')}
                />

                <FoodCard
                    mealType="lunch"
                    restaurant="Domino's 🍕"
                    time="12:00"
                    items={[
                        ['Pizza', 'Pepperoni, Cheese, Veggie'], 
                        ['Chicken Wings', 'Regular Style'],
                        ['Cheesy Bread', 'Cheesy baked breadsticks']
                    ]}
                    imageSrc={require('../assets/dominos.webp')}
                />
            </>
        ),
    },
};